import type { JSONContent } from '@tiptap/core';

import type { SpectrumColor, SpectrumColorEntry } from './blocks';

interface WorkplaceColorSpectrumFixedCopyEntry {
  title: string;
  description: string;
}

export const WORKPLACE_COLOR_SPECTRUM_COLOR_COPY = {
  green: {
    title: 'Positive',
    description:
      "Green is intentionally Positive. It means consciously shifting your perspective, being socially aware and respectful of others. You bring your best self to work when you're green.",
  },
  yellow: {
    title: 'Reactive',
    description:
      "Yellow is Reactive. It means being unconscious and thoughtless of people and situations. You're not your best self when yellow.",
  },
  orange: {
    title: 'Disturbing',
    description:
      "Orange is Disturbing. It means consciously engaging in risky behavior by referencing legally protected characteristics regardless of co-workers' comfort. You're engaging in risky behavior when you're orange.",
  },
  red: {
    title: 'Illegal',
    description:
      'Red is Illegal. It means the orange behavior is not trivial, and is negatively affecting and making the workplace toxic. Red conduct is illegal.',
  },
} as const satisfies Record<SpectrumColor, WorkplaceColorSpectrumFixedCopyEntry>;

function createParagraphContent(text: string): JSONContent {
  return {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [{ type: 'text', text }],
      },
    ],
  };
}

export function createWorkplaceColorSpectrumColorEntries(): Record<SpectrumColor, SpectrumColorEntry> {
  return {
    green: {
      title: WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.green.title,
      description: createParagraphContent(WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.green.description),
    },
    yellow: {
      title: WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.yellow.title,
      description: createParagraphContent(WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.yellow.description),
    },
    orange: {
      title: WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.orange.title,
      description: createParagraphContent(WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.orange.description),
    },
    red: {
      title: WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.red.title,
      description: createParagraphContent(WORKPLACE_COLOR_SPECTRUM_COLOR_COPY.red.description),
    },
  };
}
